import React from "react";
import { Link } from "react-router-dom";


class Header extends React.Component {
  shouldComponentUpdate() {
    return false;
  }
	render() {
		return(
			<header id="header">
        <a href="/">
          <img className="logo" src="/images/nuevoLogoRehilete.png" alt="Logo" style={{width:"140px",heigth:"70px", marginTop:"1px"}}/>
        </a>
        <nav id="nav">
          <ul>
            <li>
              <Link to="/">Inicio</Link>
            </li>
            <li>
              <Link to="/quienes">¿Quiénes Somos?</Link>
            </li>
            <li>
              <Link to="/areasyservicios">Areas y Servicios</Link>
            </li>
            <li>
              <Link to="/visita">Planea Tu Visita</Link>
            </li>
            <li>
              <Link to="/blog">Blog</Link>
            </li>
            <li>
              <Link to="/reservaciones">Reservaciones</Link>
            </li>
            <li>
              <Link to="/transparencia">Transparencia</Link>
            </li>
          </ul>
        </nav>
      </header>
		);
	}
}

export default Header;